import * as React from 'react';

const FullContainerWidth = (props: any) => (
    <div className={props.className} style={{ width: '100%' }} onClick={props.onClick}>{props.children}</div>
);

export default FullContainerWidth;